import { createFileRoute } from '@tanstack/react-router';
import { NotificationsPage } from '@/features/notifications/NotificationDetail';

/** Tutti gli avvisi ricevuti; `?open=` apre la scheda di uno. */
export const Route = createFileRoute('/_app/notifications/')({
  component: NotificationsRoute,
  validateSearch: (s: Record<string, unknown>): { open?: string } =>
    (typeof s.open === 'string' && s.open ? { open: s.open } : {}),
});

function NotificationsRoute() {
  return <NotificationsPage openId={Route.useSearch().open ?? null} />;
}
